import React from 'react';
import { Input, Row, Col } from 'reactstrap'

function CustomSelect(props) {

    return (
        <Row className="mt-3">
          <Col xs="4">{props.name}</Col>
          <Col xs="8">
            <Input type="select" name="select" value={props.selectedValue} onChange={props.onChange}>
                <option disabled value=""> -- select an option -- </option>
              {props.options.map((option) => (
                  <option
                      key={option.value}
                      value={option.value}
                  >
                    {option.name}
                  </option>
              ))}
                <optgroup className="d-none" label=""></optgroup>
              </Input>
          </Col>
      </Row>
  );
}

export default CustomSelect;